import type { getLuxLoyaltyProgramConfig } from '~/services/LuxLoyalty';

import currencyFormatter from '~/utils/currencyFormatter';

type ProgramConfigBenefit = NonNullable<Awaited<ReturnType<typeof getLuxLoyaltyProgramConfig>>>['benefits'][number];

type BenefitValue = NonNullable<App.LuxLoyaltyBenefit['details']['value']>;

function isAvailableTierConfig(
  tierConfig: ProgramConfigBenefit['tiers'][keyof ProgramConfigBenefit['tiers']],
): tierConfig is Extract<typeof tierConfig, { available: true }> {
  return !!tierConfig && 'available' in tierConfig && tierConfig.available === true;
}

/** Region-aware benefit value from program configuration, falling back to the account payload. */
export function resolveBenefitDisplayValue(
  programBenefits: ProgramConfigBenefit[] | undefined,
  benefit: App.LuxLoyaltyBenefit,
  tier: App.LuxLoyaltyTier,
): BenefitValue | undefined {
  const configBenefit = programBenefits?.find((item) => item.code === benefit.code);
  const tierConfig = configBenefit?.tiers?.[tier];

  if (isAvailableTierConfig(tierConfig) && tierConfig.value) {
    return tierConfig.value;
  }

  return benefit.details.value;
}

export function formatBenefitValue(value: BenefitValue, options: { includeEachSuffix?: boolean } = {}): string {
  const { includeEachSuffix = true } = options;

  if (value.unit === 'CURRENCY' && value.currency) {
    const formatted = currencyFormatter(value.currency, value.amount, 2, 'code');
    return includeEachSuffix ? `${formatted} each` : formatted;
  }
  if (value.unit === 'PERCENTAGE') {
    return `${value.amount}% off`;
  }
  if (value.unit === 'GB') {
    return `${value.amount} GB`;
  }
  return `${value.amount}`;
}
